"use client";
import React, { useState, useEffect } from "react";
import IMAGES from "../../data/assetData";
import Link from "next/link";
import Image from "next/image";

const RecentPicks = ({ blogs, loading, error }) => {
    return (
        <div>
            <h2 className="text-2xl font-bold mb-4 lg:pt-8">Recent Picks</h2>

            {loading ? (
                <p className="text-gray-500">Loading...</p>
            ) : error ? (
                <p className="text-red-500">{error}</p>
            ) : blogs.length > 0 ? (
                blogs.slice(0, 4).map((item, index) => (
                    <Link key={item.url || index} href={`/blog/${encodeURIComponent(item.url)}/`}>
                        <div className="flex items-center gap-4 lg:pr-2 lg:py-2 mb-4 border-b pb-3 cursor-pointer">
                            <Image
                                src={item.metaImageUrl?.match(/\.(jpg|jpeg|png|webp|gif)$/i) ? item.metaImageUrl : IMAGES.blogDefaultImg}
                                height={80}
                                width={80}
                                alt={item.title || "Thumbnail"}
                                className="rounded-md"
                            />
                            <div>
                                <p className="font-medium line-clamp-2">{item.title || "Coming Soon!"}</p>
                                <p className="text-xs text-gray-500">Published in Sukuto · 7 min read · March 25</p>
                            </div>
                        </div>
                    </Link>
                ))
            ) : (
                <p className="text-gray-500">No blogs found.</p>
            )}
        </div>
    );
};

const RecommendedTopics = ({ blogs, loading, error }) => {
    const topics = blogs.slice(0, 10); // Extract first 10 blogs to display

    return (
        <div>
            <h2 className="text-2xl font-bold mb-4">Recommended Topics</h2>

            {loading ? (
                <p className="text-gray-500">Loading...</p>
            ) : error ? (
                <p className="text-red-500">{error}</p>
            ) : topics.length > 0 ? (
                <div className="flex flex-wrap gap-3">
                    {topics.map((blog, index) => (
                        <Link key={blog.url || index} href={`/blog/${encodeURIComponent(blog.url)}/`}>
                            <span className="bg-gray-100 text-gray-700 text-sm font-medium px-4 py-2 
                                rounded-full hover:bg-blue-600 hover:text-white transition duration-300 
                                cursor-pointer shadow-md h-12 flex items-center">
                                {blog.title}
                            </span>
                        </Link>
                    ))}
                </div>
            ) : (
                <p className="text-gray-500">No recommended topics available.</p>
            )}
        </div>
    );
};

const RecentPicksContainer = () => {
    const [blogLists, setBlogLists] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/data/blog`);
                if (!res.ok) throw new Error("Blog data not found");
                const data = await res.json();
                setBlogLists(data.blogs || []);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <>
            <RecentPicks blogs={blogLists} loading={loading} error={error} />
            <RecommendedTopics blogs={blogLists} loading={loading} error={error} />
        </>
    );
};

export { RecommendedTopics };
export default RecentPicksContainer;
